"use strict";
var PolicyViewConfig = (function () {
    function PolicyViewConfig() {
    }
    return PolicyViewConfig;
}());
exports.PolicyViewConfig = PolicyViewConfig;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-config-models/policy-view-config.model.js